import React from 'react';

export const PageSkeleton: React.FC = () => <div>loading...</div>;
